import clsx from 'clsx';
import { useContext, useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { Globe } from 'components/icons';

import { LocaleContext } from '../Layout';
import { Link } from '../Link';

type Props = {
  className?: string;
  darkBg: boolean;
  location: any;
  pageIsMultilingual: boolean;
};

export const LocaleSwitch = ({ className, darkBg, location, pageIsMultilingual }: Props) => {
  const locale = useContext(LocaleContext);
  const [redirect, setRedirect] = useState('');

  useEffect(() => {
    locale === 'en'
      ? setRedirect(`/fr${location.pathname}${location.search}${location.hash}`)
      : setRedirect(location.pathname.slice(3) + location.search + location.hash);
  }, [locale, location.pathname, location.search, location.hash]);

  return pageIsMultilingual ? (
    <Link
      aria-label={`Link to the ${{ en: 'French', fr: 'English' }[locale]} version of the site`}
      className={twMerge(
        clsx(
          'flex items-center px-16 text-grey-500 hover:text-grey-500 focus:text-grey-500 active:text-grey-500',
          darkBg && 'text-white hover:text-white focus:text-white active:text-white',
          className,
        ),
      )}
      target="_self"
      href={redirect}
    >
      <Globe className="mr-12" />
      <p className="mb-0 text-md font-medium">{{ en: 'FR', fr: 'EN' }[locale]}</p>
    </Link>
  ) : null;
};
